import ProcessForwardedAction       from '../util/title-actions/processForwardedAction';
import PatronMediaItemsModel        from '../models/patron_media_items';
import HashManager                  from '../components/common/HashManager';

import TitleCollection              from '../components/media/models/TitleCollection';
import TitleCollectionView          from '../components/media/TitleCollectionView';
import TitleCard                    from '../components/media/TitleCard';
import TitleCardListView            from '../components/media/TitleCardListView';
import TitleCollectionViewSelector  from '../components/media/views/TitleCollectionViewSelector';

import PageManager                  from '../components/collection_campaign_page/PageManager';
import RtlPreviewCollection         from '../components/rtl_preview/RtlPreviewCollection';

const { Logger, featureManager }    = window;
const { currentRoom }               = window.OverDrive;

class Search {
    constructor({ bus, room, collectionDefinition }) {
        this.bus                  = bus;
        this.room                 = room;
        this.collectionDefinition = collectionDefinition;

        this.$resultsContainer = $('.js-media-results');

        this.viewState           = new TitleCollectionViewSelector({ el: '.SearchViewOptions', bus: this.bus }).model;
        this.titleCollection     = new TitleCollection(this.titles);

        this.titleCollectionView = new TitleCollectionView({
            collection              : this.titleCollection,
            bus                     : this.bus,
            patronMediaItemsModel   : new PatronMediaItemsModel({titles: this.titles}),
            attributes              : this.attributes,
            View                    : this.collectionView,
            coverWidths             : this.coverWidths,
            context                 : {
                room                : this.room,
                collectionDefinition: this.collectionDefinition
            }
        });

        this.viewState.on('change', () => {
            this.titleCollectionView.View       = this.collectionView;
            this.titleCollectionView.attributes = this.attributes;
            this.titleCollectionView.coverSizes = this.coverWidths;
            this.titleCollectionView.render();
        });

        this.handledForwardedAction = false;

        this.render();
    }

    get attributes() {
        let attributes = {
            class: 'js-title-collection-view large-block-grid-4 medium-block-grid-4 small-block-grid-2'
        };

        if (this.viewState.get('view') === 'list') {
            attributes.class = 'js-title-collection-view list-view-ul';
        }

        return attributes;
    }

    get coverWidths() {
        if (this.viewState.get('view') === 'list') {
            return {mobile: 120, tablet: 160, desktop: 160};
        }
        return {mobile: 220, tablet: 220, desktop: 220};
    }

    get collectionView() {
        let View;

        if (this.viewState.get('view') === 'list') {
            View = TitleCardListView;
            this.$resultsContainer.removeClass('grid-view').addClass('list-view');
        } else {
            View = TitleCard;
            this.$resultsContainer.removeClass('list-view').addClass('grid-view');
        }

        return View;
    }

    get titles() {
        return window.OverDrive.titleCollection; // The source of data here is subject to change
    }

    render() {
        $('.js-media-results').prepend(this.titleCollectionView.$el);

        /// $(document).foundation();

        // This event should happen after the search page is fully done rendering.
        // TODO: revisit this strategy when search page is fully componentized.
        // Slack reference: https://overdrive.slack.com/archives/lightning-dev/p1488381226000227
        window.globalEvents.trigger('search:render');

        // It's possible for render() to be called multiple times in some situations.  We don't want to trigger the action twice.
        if (window.OverDrive.isAuthenticated && window.OverDrive.hasLinkedCards && HashManager.get('action') && this.handledForwardedAction) {
            this.handledForwardedAction = true;
            let forwardedAction = new ProcessForwardedAction(this.titleCollection, this.bus);
            forwardedAction.executeAction();
            window.forwardAction = forwardedAction;
        }

        // Show pagination TODO: Refactor pagination into component to be appended to page here
        $('.Pagination.is-results').show();
    }
}

$('.RTLRecommendations').each((i, el) => {
    void (new RtlPreviewCollection({ bus: window.globalEvents, el, featureManager }));
});

import FacetsController from './facets/facets_controller.js';
window.facetsController = new FacetsController();

if (!!window.collectionId) {
    let pageManager = new PageManager();

    pageManager.fetchCollectionById(window.collectionId).then(
        (collectionDefinition) => {
            void (new Search({ bus: window.globalEvents, room: currentRoom, collectionDefinition }));
        },
        (jqHXR, textStatus, error) => {
            Logger.log('error', 'Error fetching collection', {message: textStatus});
        }
    );
}
else {
    void (new Search({ bus: window.globalEvents, room: currentRoom }));
}

